<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<div><a id="listoftables"></a></div><a id="listoftables">
<h1>LIST OF TABLES</h1>
<p class="bigspace"> </p>
</a><p class="table"><a id="listoftables"></a><span href="#/html/17_chap11#table1" title="Link target outside of Sample">Table 1 Frequencies for Hardways Set, Random Dice</span></p>
<p class="table"><span href="#/html/17_chap11#table2" title="Link target outside of Sample">Table 2 Frequencies for Setting Sevens, Random Dice</span></p>
<p class="table"><span href="#/html/17_chap11#table3" title="Link target outside of Sample">Table 3 Frequencies for 3-V Set, Random Dice</span></p>
<p class="table"><span href="#/html/18_chap12#table4" title="Link target outside of Sample">Table 4 All Possible Dice Sets</span></p>
<p class="table"><span href="#/html/18_chap12#table5" title="Link target outside of Sample">Table 5 Faces Received From Stick Person: Empirical Results</span></p>
<p class="table"><span href="#/html/18_chap12#table6" title="Link target outside of Sample">Table 6 Dice Sets: Frequencies</span></p>
<p class="table"><span href="#/html/19_chap13#table7" title="Link target outside of Sample">Table 7 All 36 Rolls of Two Dice</span></p>
<p class="table"><span href="#/html/19_chap13#table8" title="Link target outside of Sample">Table 8 Distribution of Random Rolls</span></p>
<p class="table"><span href="#/html/19_chap13#table9" title="Link target outside of Sample">Table 9 Hand Lengths for Various SRRs</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_list_of_tables.vue?5032d962